import { Modal, Typography } from 'antd';
import { MessageInstance } from 'antd/es/message/interface';
import { isEqual } from 'lodash';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import CreateOrderForm from './CreateOrderForm';
const { Title } = Typography;

interface CreateOrderModal {
  institutionId?: Parameters<typeof CreateOrderForm>[0]['institutionId'];
  visible?: boolean;
  onCancel?: Parameters<typeof CreateOrderForm>[0]['onCancel'];
  onFinish?: Parameters<typeof CreateOrderForm>[0]['onFinish'];
  defaultValues?: Parameters<typeof CreateOrderForm>[0]['defaultValues'];
  disablePatientSearch?: Parameters<typeof CreateOrderForm>[0]['disablePatientSearch'];
  message: MessageInstance;
}

const CreateOrderModal = ({
  institutionId,
  visible,
  onCancel,
  onFinish = null,
  defaultValues,
  disablePatientSearch,
  message,
}: CreateOrderModal) => {
  const { t } = useTranslation('Vindoc');

  return (
    <Modal
      className="vindr-modal add-order max-w-screen"
      title={false}
      open={visible}
      maskClosable={false}
      destroyOnClose
      zIndex={1001}
      onCancel={onCancel}
      footer={null}
      width={900}
    >
      <Title level={3} className="mb-6">
        {t('Add Order')}
      </Title>
      <CreateOrderForm
        {...{ institutionId, onCancel, onFinish, defaultValues, disablePatientSearch, message }}
      />
    </Modal>
  );
};

export default memo(CreateOrderModal, (prevProps, nextProps) => {
  return isEqual(prevProps.defaultValues, nextProps.defaultValues);
});
